import { INDICES } from '../../../../algolia-search/helper/algoliaHelper';

type QuerySuggestionsIndex = 'PRODUCT_QUERY_SUGGESTIONS_NL_NL'
| 'PRODUCT_QUERY_SUGGESTIONS_NL_BE' | 'PRODUCT_QUERY_SUGGESTIONS_FR_BE'
| 'PRODUCT_QUERY_SUGGESTIONS_FR_FR';

export const getIndicesForLocale = (locale: string) => {
  const localeForSuggestions = locale.toUpperCase().replace('-', '_');
  return INDICES[`PRODUCT_QUERY_SUGGESTIONS_${localeForSuggestions}` as QuerySuggestionsIndex];
};
